import { z } from 'zod';

export const oAuthProviderNameSchema = z.union([z.literal('google'), z.literal('apple')]);

export type OAuthProviderName = z.infer<typeof oAuthProviderNameSchema>;
